import Yup from '@fourthwall/utils/dist/yup';
export const getChargeLimitValidationSchema = (setChargeLimitFieldName = 'setChargeLimit', chargeLimitFieldName = 'chargeLimit') => ({
    [setChargeLimitFieldName]: Yup.boolean(),
    [chargeLimitFieldName]: Yup.number().when(setChargeLimitFieldName, {
        is: true,
        then: Yup.number().required().min(0),
    }),
});
